import styled from 'styled-components';

import { fieldContainer, fieldLabel, fieldMessage } from '../base';

/**
 * The design's `.upload-sq` — the small square uploader beside a form row.
 *
 * It replaces a 40px `#616e84` disc with a white plus punched out of it and a
 * 24px `#eef1f6` pen badge hung off its right edge at `right: -15px`, which
 * put the control's only affordance outside its own box. Both call sites are
 * group 8: the event speaker portraits and the ticket category icon.
 */

export const inputContainer = styled.div`
  ${fieldContainer}
  width: auto;
`;

export const label = styled.label`
  ${fieldLabel}
`;

export const message = styled.span`
  ${fieldMessage}
`;

export const img = styled.img`
  &.icon {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

/* The replace affordance, inside the box rather than hanging off it. */
export const Icon = styled.div`
  position: absolute;
  right: var(--s1);
  bottom: var(--s1);
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border-radius: var(--r-sm);
  background: var(--surface);
  border: 1px solid var(--line);
  color: var(--text-muted);
  line-height: 0;

  svg {
    width: 11px;
    height: 11px;
    stroke-width: 1.9;
  }
`;

export const InputBox = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  width: 72px;
  height: 72px;
  flex: 0 0 72px;
  border-radius: var(--r-md);
  border: 1.5px dashed var(--line-strong);
  background: var(--surface-alt);
  color: var(--text-faint);
  cursor: pointer;
  overflow: hidden;
  transition:
    background-color 0.12s,
    border-color 0.12s,
    color 0.12s;

  &:hover,
  &.dragging {
    border-color: var(--primary);
    color: var(--primary);
    background: var(--primary-soft);
  }

  /* Once it holds a picture it is a preview, so the dashed rule goes solid. */
  &.filled {
    border-style: solid;
    border-color: var(--line);
    background: var(--surface);
  }

  svg {
    width: 20px;
    height: 20px;
    stroke-width: 1.6;
  }
`;

export const Div = styled.div``;
